const TWENTY_FOUR_HOURS_IN_MS = 86400000

export const isDateOlderThan24Hours = (completedDate: string | null) => {
  return completedDate && new Date().getTime() - new Date(completedDate).getTime() > TWENTY_FOUR_HOURS_IN_MS
}
